import { useState, type ReactNode } from "react";
import { Confetti } from "@/components/ui/Confetti";
import { Icon } from "@/components/ui/Icon";
import { t } from "@/lib/strings";

/**
 * The Ideenbox-only success state shown after an idea is submitted: a one-shot
 * confetti burst + a warm "Danke für deine Idee!". Reused by the submit modal
 * and the standalone /danke page. Callers pass their own action buttons as
 * children (modal: close/another; page: link to submit another).
 *
 * The orange badge uses a fixed translucent bg + fixed brand-orange icon, so it
 * reads in both themes (not the flipping-token-with-hardcoded-hex footgun).
 */
export function IdeaThankYou({ children }: { children?: ReactNode }) {
  const [bursting, setBursting] = useState(true);

  return (
    <div style={{ textAlign: "center", padding: "10px 4px 4px" }}>
      {bursting ? <Confetti onDone={() => setBursting(false)} /> : null}
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: 999,
          background: "rgba(246,129,33,0.16)",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 14,
        }}
      >
        <Icon name="lightbulb" size={28} stroke={2.2} color="#F68121" />
      </div>
      <h2
        style={{
          margin: 0,
          fontSize: 21,
          fontWeight: 600,
          color: "var(--ink-1)",
          letterSpacing: "-0.01em",
        }}
      >
        {t.ideaThanksTitle}
      </h2>
      <p style={{ margin: "10px 0 0", fontSize: 14, color: "var(--ink-3)", lineHeight: 1.5 }}>
        {t.ideaThanksBody}
      </p>
      {children ? (
        <div style={{ marginTop: 20, display: "flex", gap: 10, justifyContent: "center" }}>
          {children}
        </div>
      ) : null}
    </div>
  );
}
